import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import {
  createOrder,
  createPaymentOrder,
  verifyPayment,
} from "../../api";
import { useLocation } from "react-router-dom";
function Payment() {
  const navigate = useNavigate();

  const { cart, clearCart } = useContext(CartContext);

  const [paymentMethod, setPaymentMethod] = useState("online");
  const [loading, setLoading] = useState(false);


const location = useLocation();

const customer = location.state?.customer || {};
  const total = cart.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const orderItems = cart.map((item) => ({
    productId: item._id,
    title: item.title,
    image: item.image,
    price: item.price,
    quantity: item.quantity,
    category: item.category,
    brand: item.brand,
    description: item.description,
    specifications: item.specifications,
    features: item.features,
  }));

  const handleCODOrder = async () => {
    try {
      setLoading(true);

     await createOrder({
  items: orderItems,
  amount: total,
  paymentMethod: "COD",
  paymentStatus: "Pending",

  shippingAddress: {
    name: customer.name,
    email: customer.email,
    phone: customer.phone,
    address: customer.address,
    city: customer.city,
    state: customer.state,
    pincode: customer.pincode,
  },
});

      clearCart();

      alert("Order Placed Successfully");

      navigate("/order-success");
    } catch (error) {
      console.error(error);
      alert("Order Failed");
    } finally {
      setLoading(false);
    }
  };

  const handleOnlinePayment = async () => {
    try {
      setLoading(true);

      const response = await createPaymentOrder({
        amount: total,
      });

      const data = response.data || response;

      if (!data.success) {
        alert("Unable to create payment order");
        return;
      }

      const options = {
        key: data.key,
        amount: data.order.amount,
        currency: data.order.currency,
        order_id: data.order.id,

        name: "Polybionic Technologies",
        description: "Order Payment",

        prefill: {
          name: "Customer",
          email: "customer@example.com",
          contact: "9999999999",
        },

        notes: {
          source: "website",
        },

        theme: {
          color: "#16a34a",
        },

        handler: async function (razorpayResponse) {
          try {
            const verifyRes = await verifyPayment({
              razorpay_order_id:
                razorpayResponse.razorpay_order_id,

              razorpay_payment_id:
                razorpayResponse.razorpay_payment_id,

              razorpay_signature:
                razorpayResponse.razorpay_signature,
            });

            const verifyData =
              verifyRes.data || verifyRes;

            if (!verifyData.success) {
              alert("Payment Verification Failed");
              return;
            }

            await createOrder({
              items: orderItems,
              amount: total,

              paymentMethod: "ONLINE",
              paymentStatus: "Paid",

              razorpayOrderId:
                razorpayResponse.razorpay_order_id,

              razorpayPaymentId:
                razorpayResponse.razorpay_payment_id,
            });

            clearCart();

            alert("Payment Successful");

            navigate("/order-success");
          } catch (error) {
            console.error(error);

            alert("Order Save Failed");
          }
        },

        modal: {
          ondismiss: function () {
            console.log("Payment popup closed");
          },
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        console.log(response);

        alert(
          response.error?.description ||
            "Payment Failed"
        );
      });

      rzp.open();
    } catch (error) {
      console.error(error);

      alert("Payment Failed");
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async () => {
    if (cart.length === 0) {
      alert("Your cart is empty");
      return;
    }

    if (paymentMethod === "cod") {
      return handleCODOrder();
    }

    return handleOnlinePayment();
  };

  return (
    <div className="max-w-2xl mx-auto py-20 px-5">
      <div className="bg-white p-8 rounded-2xl shadow-lg">
        <h1 className="text-3xl font-bold mb-6">
          Payment
        </h1>

        <div className="border rounded-xl p-4 mb-6 bg-gray-50">
          <p className="font-semibold text-gray-600">
            Total Amount
          </p>

          <h2 className="text-4xl font-bold text-green-600">
            ₹{total}
          </h2>
        </div>

        <h3 className="text-xl font-semibold mb-4">
          Select Payment Method
        </h3>

        <div className="space-y-4">
          <label className="flex items-center gap-3 border p-4 rounded-lg cursor-pointer">
            <input
              type="radio"
              value="online"
              checked={paymentMethod === "online"}
              onChange={(e) =>
                setPaymentMethod(e.target.value)
              }
            />
            Razorpay (UPI, Cards, Net Banking,
            Wallets)
          </label>

          <label className="flex items-center gap-3 border p-4 rounded-lg cursor-pointer">
            <input
              type="radio"
              value="cod"
              checked={paymentMethod === "cod"}
              onChange={(e) =>
                setPaymentMethod(e.target.value)
              }
            />
            Cash On Delivery
          </label>
        </div>

        <button
          onClick={handlePayment}
          disabled={loading || cart.length === 0}
          className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white py-3 rounded-lg mt-8 transition"
        >
          {loading
            ? "Processing..."
            : paymentMethod === "cod"
            ? "Place Order"
            : `Pay ₹${total}`}
        </button>
      </div>
    </div>
  );
}

export default Payment;